import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import {TextField, Checkbox, FormControlLabel, Stack, Snackbar, Alert } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
///import FormLabel from '@mui/material/FormLabel';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  
  const [tempBody, setTempBody] = React.useState("");
  const [during, setDuring] = React.useState("Before");
  const [days, setDays] = React.useState(0);
  const [daysActive, setDaysActive] = React.useState(false);
  const [apiUrlSuffix, setApiUrlSuffix] = React.useState("");
  const [active, setActive] = React.useState(false);

  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    if(props.dataObj && props.dataObj.autoId){	
      setTempBody(props.dataObj.tempBody);
      setDuring(props.dataObj.during);
      setDays(props.dataObj.days);
      setApiUrlSuffix(props.dataObj.apiUrlSuffix);
      if(props.dataObj.daysActive===1){
        setDaysActive(true);
      }else{
        setDaysActive(false);
      }
      if(props.dataObj.active===1){
        setActive(true);
      }else{
        setActive(false);
      }
    
    }
	}, [props.dataObj,open]);

	function saveData(){
    if(!tempBody){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter message");			
      return false;
    }
    
		if(tempBody && tempBody.length>1){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			}; 
			const data = new FormData();
      data.append('id', props.dataObj.autoId);
      data.append('tempBody', tempBody);
      data.append('during', during);
      if(props.dataObj.daysActive===1){
        data.append('daysActive', 1);
      }else{
        data.append('daysActive', 0);
      }
      if(days>0){
        data.append('days', days);
      }else{
        data.append('days', 0);
      }

      data.append('apiUrlSuffix', apiUrlSuffix);
      
      if(active===true){
        data.append('active', 1);
      }else{
        data.append('active', 0);
      }

			axios.post(API_URL+'/crm-update-sms-templates', data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){          
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Template has been updated.");
          window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="alreadyexistserror"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This template name was created earlier. Kindly enter another template name.");
            return false;  					

        }else if(response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');
  
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This template name could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}
  

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'88vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.dataObj!=null?<>Edit</>:<>New</>} SMS Template</h3></div>
                  <p>
                      <table style={{width:'100%' }} cellSpacing="1" cellPadding="5" >
                        <tr>
                            <td>
                            <TextField label='Message' onChange={event => setTempBody(event.target.value)} value={tempBody} placeholder={'Enter message'} fullWidth variant="outlined" multiline rows={5} />
                            </td>                            
                        </tr>
                      {daysActive?  
                        <tr>
                            <td>
                              <FormControl>
                                <RadioGroup
                                  aria-labelledby="demo-radio-buttons-group-label"
                                  defaultValue="Before"
                                  name="radio-buttons-group"
                                  row
                                  value={during}
                                  onChange={event => setDuring(event.target.value)}
                                >
                                  <FormControlLabel value="Before" control={<Radio />} label="Before" />
                                  <FormControlLabel value="After" control={<Radio />} label="After" />
                                  <FormControlLabel value="Same Day" control={<Radio />} label="Same Day" />
                                </RadioGroup>
                              </FormControl>
                            <TextField label='Days' size='small' onChange={event => setDays(event.target.value)} value={days} placeholder={'Enter days'} fullWidth variant="outlined" />
                            </td>                            
                        </tr>
                      :null}  
                        <tr>
                            <td>
                            <TextField label='API URL Suffix' onChange={event => setApiUrlSuffix(event.target.value)} value={apiUrlSuffix} placeholder={'Enter API URL Suffix'} fullWidth variant="outlined" />
                            <small>Example: param1=value1&param2=value2</small>
                            </td>                            
                        </tr>
                        <tr>
                            <td>
                              <FormControlLabel
                                control={
                                  <Checkbox checked={active} onChange={event => setActive(event.target.checked)} />
                                }
                                label="Active"
                              />
                            </td>                            
                        </tr>

                      </table>
                      
                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF'}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;